module.exports = __webpack_public_path__ + "static/media/loadingwave.ceb54145.gif";